//====================================================
//  Initialization typed text
//====================================================

function fn_components_typed(){
	if ($('.js-typing-text').length){
		
		// var menuItems = {
		// 	'rules': 'Follow <br> the code',
		// 	'story': 'Lorem ipsum <br> dolor sit amet',
		// 	'work': 'Expect <br> expected',
		// 	'contact': "Here's my <br> number",
		// 	'shop': "Cool merch <br> inside"
		// }

		// $( '.js-typing-hover' ).hover(function(){
			// var inst = $( '.js-typing-hover' );
			var typed = $( '.js-typing-text' );
			// var text = typed.data( 'id' );

			// console.log(menuItems[text]);

			typed.typed({
				strings: 'ahoje qweqw eqw eqwe wqewq eqw eqwe qwewq ewqe qwe wqeqw qw wq',
				typeSpeed: 50
				// backDelay: 1000,
				// backSpeed: 50,
				// loop: loop,
				// cursorChar: "|"
			});
		// });
	}
}